import React from "react";
import { cn } from "../../helpers/classNames";
import styles from "./styles.module.scss";

type Props = {
    children: React.ReactNode;
    fullWidth?: boolean;
    type:
        | "snowPrimary"
        | "snowSecondary"
        | "weatherPrimary"
        | "weatherSecondary"
        | "weatherTertiary";
};

export const LookalikeLink: React.FC<Props> = ({
    children,
    type,
    fullWidth,
}) => {
    return (
        <div
            className={cn(
                [
                    "weatherPrimary",
                    "weatherSecondary",
                    "weatherTertiary",
                ].includes(type) && styles.weatherButton,
                ["snowPrimary", "snowSecondary"].includes(type) &&
                    styles.snowButton,
                styles[type],
                fullWidth && styles.fullWidth
            )}
        >
            {children}
        </div>
    );
};
